import {KeyModel} from "../models";
import {patchState, signalStore, withMethods, withState} from "@ngrx/signals";
import {KeyTypeEnum} from "../enums";

type KeysState = {
	keys: KeyModel[]
}

const initialState: KeysState = {
	keys: []
}

export const KeyStore = signalStore(
	{providedIn: 'root'},
	withState(initialState),
	withMethods(store => ({
		getKey(type: KeyTypeEnum): KeyModel {
			return store.keys().find(key => key.type === type) as KeyModel;
		},
		getAllKeys(): KeyModel[] {
			return store.keys();
		},
		saveOrUpdateKey(key: KeyModel): void {
			const keyToUpdateIndex = store.keys().findIndex(storeKey => storeKey.type === key.type);
			if (keyToUpdateIndex > -1) {
				const updatedKeys: KeyModel[] = store.keys();
				store.keys()[keyToUpdateIndex].value = key.value;
				patchState(store, () => ({keys: updatedKeys}));
			} else {
				patchState(store, state => ({keys: [...state.keys, key]}));
			}
		},
		deleteKey(type: KeyTypeEnum): void {
			const updatedKeys: KeyModel[] = store.keys().filter(storeKey => storeKey.type !== type);
			patchState(store, () => ({keys: updatedKeys}));
		}
	}))
)